import { LastUpdatedAt } from '../../LastUpdatedAt'

export function DataSource({ lastUpdatedAt }) {
  return (
    <>
      <div className="mx-4 mb-4 flex items-center gap-2 rounded bg-default p-2">
        {lastUpdatedAt && (
          <LastUpdatedAt
            value={lastUpdatedAt}
            className="!mt-0"
            testId="txt-detail-last-updated-at"
          />
        )}
      </div>
    </>
  )
}
